<template>
  <div>
    <b-card
      no-body
      class="my-1"
      :class="{ 'card-transparent-background': type == 'register' }"
    >
      <b-card-header
        class=""
        :class="{
          'card-header-profile-border': type == 'profile' || type == 'edit',
          'card-header-form-doorder': type == 'register',
        }"
      >
        <b-row>
          <b-col lg="7" md="6"><h4>Contact Details</h4> </b-col>
          <b-col lg="5" md="6"
            ><div
              class="justify-content-right float-right"
              v-if="type != 'profile'"
            >
              <b-button
                type="button"
                variant="doorder-primary"
                class="
                  btn-bumblebee
                  btn-doorder
                  btn-doorder-filter
                  btn-doorder-add-item
                  mt-0
                "
                @click="addContact()"
              >
                Add contact
              </b-button>
            </div></b-col
          >
        </b-row></b-card-header
      >

      <b-card-body
        class=""
        :class="{
          'py-2 px-4': type == 'profile' || type == 'edit',
          'py-0': type == 'register',
        }"
      >
        <div class="container">
          <b-row>
            <b-col
              md="12"
              class="my-2 mb-4"
              :class="{
                'profile-border-div-doorder':
                  type == 'profile' || type == 'edit',
              }"
              v-for="(contact, index) in contacts"
              :key="index+1"
            >
              <h5 class="location-label-doorder card-title">
                Contact {{ index + 1 }}

                <span
                  v-if="index != 0 && type != 'profile'"
                  class="float-sm-right"
                >
                  <img
                    class="remove-icon-doorder"
                    src="@/assets/images/doorder/remove-icon.png"
                    @click="removeContact(index)"
                  />
                </span>
              </h5>
              <b-row>
                <b-col sm="6">
                  <b-form-group
                    class="form-group-doorder"
                    :label="type == 'register' ? '' : 'Contact name'"
                    :label-for="'name' + (index + 1)"
                    label-class="form-label-doorder"
                  >
                    <p
                      class="error_validation_message_p"
                      v-if="contact.invalid_name"
                    >
                      Please enter name
                    </p>
                    <b-form-input
                      v-if="type == 'register' || type == 'edit'"
                      :id="'name' + (index + 1)"
                      class="form-control-doorder"
                      v-model="contact.name"
                      :name="'name' + (index + 1)"
                      placeholder="Contact name"
                      required
                    ></b-form-input
                    ><span
                      v-if="type == 'profile'"
                      class="form-control form-control-doorder"
                    >
                      {{ contact.name }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group
                    class="mobile-number-input-group-doorder"
                    :label="type == 'register' ? '' : 'Contact number'"
                    :label-for="'phone' + (index + 1)"
                    label-class="form-label-doorder"
                  >
                    <p
                      class="error_validation_message_p"
                      v-if="contact.invalid_phone_number"
                    >
                      Please enter phone number
                    </p>
                    <vue-tel-input
                      v-if="type == 'register' || type == 'edit'"
                      class="form-control form-control-doorder"
                      :id="'phone' + (index + 1)"
                      v-model="contact.phone"
                      required
                    ></vue-tel-input
                    ><span
                      v-if="type == 'profile'"
                      class="form-control form-control-doorder"
                    >
                      {{ contact.phone }}
                    </span>
                  </b-form-group>
                  <!-- <b-form-group
                    :label="type == 'register' ? '' : 'Contact number'"
                    :label-for="'contact_number' + (index + 1)"
                    label-class="form-label-doorder"
                  >
                    <b-form-input
                      :id="'contact_number' + (index + 1)"
                      class="form-control-doorder"
                      v-model="contact.contact_number"
                      :name="'contact_number' + (index + 1)"
                      placeholder="Contact number"
                      required
                    ></b-form-input>
                  </b-form-group> -->
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <b-form-group
                    class="form-group-doorder"
                    :label="type == 'register' ? '' : 'Contact email'"
                    :label-for="'email' + (index + 1)"
                    label-class="form-label-doorder"
                  >
                    <p
                      class="error_validation_message_p"
                      v-if="contact.invalid_email"
                    >
                      Please enter email
                    </p>
                    <b-form-input
                      v-if="type == 'register' || type == 'edit'"
                      :id="'email' + (index + 1)"
                      class="form-control-doorder"
                      v-model="contact.email"
                      :name="'email' + (index + 1)"
                      placeholder="Contact email address"
                      required
                    ></b-form-input
                    ><span
                      v-if="type == 'profile'"
                      class="form-control form-control-doorder"
                    >
                      {{ contact.email }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group
                    class="form-group-doorder"
                    :label="type == 'register' ? '' : 'Location'"
                    :label-for="'location' + (index + 1)"
                    label-class="form-label-doorder"
                  >
                    <p
                      class="error_validation_message_p"
                      v-if="contact.invalid_location"
                    >
                      Please select location
                    </p>
                    <v-select
                      v-if="type == 'register' || type == 'edit'"
                      :options="contacts_locations"
                      v-model="contact.location"
                      :name="'location' + (index + 1)"
                      :title="'location' + (index + 1)"
                      placeholder="Select location"
                      :clearable="false"
                      required
                    >
                    </v-select>
                    <span
                      v-if="type == 'profile'"
                      class="form-control form-control-doorder"
                    >
                      {{ contact.location }}
                    </span>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>
 
<script>
import $ from "jquery";
import moment from "moment";
import Select2 from "v-select2-component";

export default {
  name: "ContactDetails",

  components: {
    "vue-select": require("vue-select2"),
    Select2,
  },
  props: ["type", "locations", "contacts", "contacts_locations"],
  data() {
    return {
      // contacts: [{name:"",phone:"",email:"",location:""}],
      invalid_location: false,
      location: null,
    };
  },
  mounted() {
    // console.log(this.locations)
    // console.log(this.contacts)},
  },
  updated() {
    // console.log(this.locations)
    // this.contacts_locations = []
    //   for(var i=0; i<this.locations.length; i++){
    //     this.contacts_locations.push("Location "+(i+1))
    //   }
    //   console.log(this.contacts_locations)
    // console.log(this.contacts)
  },
  methods: {
    addContact() {
      this.contacts.push({
        id: "new",
        name: "",
        phone: "",
        email: "",
        location: null,
        invalid_phone_number: false,
        invalid_location: false,
      });
      // this.timer = setTimeout(() => {
      //     this.addAutoCompleteInput();
      //     this.addBusinessHoursContainer();
      // }, 500)
    },

    removeContact(index) {
      this.contacts.splice(index, 1);
    },
  },
};
</script>

<style >
</style>


// WEBPACK FOOTER //
// src/components/doorder/retailers/profile_details_components/ContactDetails.vue